import { Linkedin } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/primitives";

const FOUNDERS = [
  {
    name: "Amey Dahanukar",
    role: "Co-founder & Principal Architect",
    bio: "Leads the design language; two decades across corporate, hospitality and experience-led interiors.",
    img: "/founder-amey.webp",
    linkedin: "https://www.linkedin.com/in/amey-dahanukar/",
  },
  {
    name: "Bhavesh Goradia",
    role: "Co-founder & MEP Expert",
    bio: "Carries the electrical legacy; heads mechanical, electrical and plumbing engineering on every contract.",
    img: "/founder-bhavesh.webp",
    linkedin: "https://www.linkedin.com/in/bhavesh-navinchandra-goradia-turnkeyelectricalengineers/",
  },
  {
    name: "Pooja Dahanukar",
    role: "Co-founder & Operations Head",
    bio: "Runs delivery end to end; procurement, vendor governance and the disciplines that keep sites on schedule.",
    img: "/founder-pooja.webp",
    linkedin: "https://www.linkedin.com/in/pooja-dahanukar-35437288/",
  },
  {
    name: "Hetvi Goradia",
    role: "Co-founder & Communications Head",
    bio: "Owns brand and client relationships; turns workplace research into spaces people love.",
    img: "/founder-hetvi.webp",
    linkedin: "https://www.linkedin.com/in/hetvi-goradia/",
  },
];

export default function Founders() {
  return (
    <section id="studio" className="bg-paper pb-24 pt-4 lg:pb-36" data-testid="founders-section">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-12">
        <Reveal>
          <Eyebrow index="05">The Studio</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-serif text-4xl text-ink sm:text-5xl">Our Co-founders</h2>
        </Reveal>
      </div>

      <div className="mt-14 grid grid-cols-2 lg:grid-cols-4" data-testid="founders-strip">
        {FOUNDERS.map((f, i) => (
          <Reveal key={f.name} delay={i * 0.08}>
            <a
              href={f.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`${f.name} on LinkedIn`}
              className="group relative block overflow-hidden"
              data-testid={`founder-card-${i + 1}`}
              data-testid-href={f.linkedin}
            >
              <span className="absolute right-4 top-4 z-10 flex h-8 w-8 items-center justify-center rounded-full bg-ink/40 text-paper/70 backdrop-blur-sm transition-colors duration-300 group-hover:bg-maroon group-hover:text-paper">
                <Linkedin size={14} strokeWidth={1.75} />
              </span>
              <img
                src={f.img}
                alt={`${f.name} · ${f.role}`}
                loading="lazy"
                className="aspect-[3/4] w-full object-cover grayscale transition-all duration-700 ease-out group-hover:scale-[1.04] group-hover:grayscale-0"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/90 via-ink/20 to-transparent opacity-80 transition-opacity duration-500 group-hover:opacity-95" />
              <div className="absolute inset-x-0 bottom-0 p-4 lg:p-6">
                <h3 className="font-serif text-lg text-paper lg:text-2xl">{f.name}</h3>
                <p className="mt-1 text-[9px] font-medium uppercase tracking-[0.18em] lg:text-[11px]" style={{ color: "#D98A86" }}>
                  {f.role}
                </p>
                <p className="mt-2 hidden text-xs leading-relaxed text-paper/80 opacity-0 transition-all duration-500 group-hover:opacity-100 lg:block">
                  {f.bio}
                </p>
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
